import dayjs from 'dayjs';

import type { GridFilterOperator } from '@packages/fenrir/components';

import { ExpirationFilterOption } from '../../../routes/security-focuses/$focusID/components/security-focus-spidrs-table';
import type { SpidrRow } from '../../../routes/security-focuses/$focusID/components/security-focus-spidrs-table';
import { expiringStates } from '../../../utils/sort-outcome-expiration-column';

import type { MultiSelectOption } from './multi-select-filter-input';
import { MultiSelectFilterInput } from './multi-select-filter-input';

export const outcomeExpirationColumnFilterOperator = (
  options: MultiSelectOption[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): GridFilterOperator<any, SpidrRow>[] => {
  return [
    {
      value: 'hasAnyOf',
      label: 'Has Any Of',
      getApplyFilterFn: (filterItem) => {
        if (filterItem.value === undefined || filterItem.value.length === 0) {
          return null;
        }
        return (value) => {
          if (!expiringStates.includes(value.state)) {
            return false;
          }

          const now = dayjs();
          const expiry = dayjs(value.nullableExpiryDate);
          const diff = expiry.diff(now, 'days');

          if (
            filterItem.value.find(
              (i: MultiSelectOption) =>
                i.value === ExpirationFilterOption.DAYS_45,
            ) &&
            diff < 45 &&
            diff > 0
          ) {
            return true;
          }

          if (
            filterItem.value.find(
              (i: MultiSelectOption) =>
                i.value === ExpirationFilterOption.DAYS_30,
            ) &&
            diff < 30 &&
            diff > 0
          ) {
            return true;
          }

          if (
            filterItem.value.find(
              (i: MultiSelectOption) =>
                i.value === ExpirationFilterOption.DAYS_15,
            ) &&
            diff < 15 &&
            diff > 0
          ) {
            return true;
          }

          if (
            filterItem.value.find(
              (i: MultiSelectOption) =>
                i.value === ExpirationFilterOption.EXPIRED,
            ) &&
            diff < 0
          ) {
            return true;
          }

          return false;
        };
      },
      InputComponent: MultiSelectFilterInput,
      InputComponentProps: {
        options,
      },
    },
  ];
};
